<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검 정보 -->
    <div class="mt-5 mb-6">
      <p class="title my-4"><i class="dot"></i>점검정보</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">담당부서</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <company-selector
            v-else
            v-model="form.inputB_0"
            @select="targetCompany"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검자명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder="날짜선택"
            v-model="form.inputB_3"
          />
        </div>
      </div>
    </div>

    <!--    도급 및 발주사업 총 건수-->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="도급 및 발주사업 총 건수"
      :tableData="[
        { id: 'input1', title: '연번', type: 'no', width: '80px' },
        { id: 'input2', title: '건명', type: 'text', placeholder: '내용' },
        {
          id: 'input3',
          title: '형태',
          type: 'select',
          selectData: [
            '도급',
            '위탁',
            '발주',
          ],
          placeholder: '선택',
        },
      ]"
      v-model="form.industryList"
    />

    <!--    점검항목-->
    <vs-row class="my-4">
      <vs-col class="flex items-center">
        <h5><i class="dot"></i>안전보건관리체계 구축 및 이행 점검표</h5>
        <div class="flex items-center cursor-pointer" @click="openPopup">
          <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />
          <span style="color: #7e72f2"> 이행사항 점검 시 작성요령 </span>
        </div>
      </vs-col>
    </vs-row>

    <!-- 신버전 테이블 -->
    <table v-show="!isOldVersion" class="inspectTable">
      <thead>
      <tr>
        <th>점검 항목</th>
        <th width="82px">이행</th>
        <th width="82px">미이행</th>
        <th width="82px">해당없음</th>
        <th width="300px">비고</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(row, index) in form.inspectList2">
        <tr v-if="row.type === 'section'" :key="index">
          <th colspan="5" style="text-align: start; padding: 10px; font-weight: 700; font-size: 14px;">{{ row.title }}</th>
        </tr>
        <tr v-else :key="index">
          <td><span v-html="row.content"/></td>
          <td>
            <vs-input class="w-full" style="width: 80px;" v-model="row.input3" :readonly="board.readonly" type="number"/>
          </td>
          <td>
            <vs-input class="w-full" style="width: 80px; padding: 0" v-model="row.input4" :readonly="board.readonly" type="number"/>
          </td>
          <td>
            <vs-input class="w-full" style="width: 80px;" v-model="row.input5" :readonly="board.readonly" type="number"/>
          </td>
          <td>
            <vs-textarea v-model="row.input6" :readonly="board.readonly" style="margin: 0px;"/>
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <!-- 구버전 테이블 -->
    <table v-show="isOldVersion" class="inspectTable">
      <thead>
      <tr>
        <th width="52px">No.</th>
        <th>점검 항목</th>
        <th width="300px">해당부서</th>
        <th width="82px">이행</th>
        <th width="82px">미이행</th>
        <th width="82px">해당없음</th>
        <th width="300px">비고</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td colspan="7" style="text-align: start; padding: 10px;">
          <span style="font-weight: 700; font-size: 14px;">안전보건관리체계 구축 및 이행 - 중처법 시행령 제4조 제9호</span>
        </td>
      </tr>
      <tr>
        <td colspan="7" style="text-align: start; padding: 10px;">
          <span style="font-weight: 500; font-size: 14px;">도급·용역·위탁시 종사자 안전보건확보기준 절차마련(반기1회점검) - 중처법 시행령 제4조 제9호<br/>
            ※ 다만, 사업주나 법인 또는 법인이 그 시설, 장비, 장소 등에 대하여 실질적으로 지배·운영·관리하는 책임이 있는 경우에 한한다.</span>
        </td>
      </tr>

      <tr v-for="(row, index) in form.inspectList">
        <td>{{index + 1}}</td>
        <td>
          <span v-html="row.input1"/>
        </td>
        <td>{{row.input2}}</td>
        <td>
          <vs-input class="w-full" style="width: 80px;" v-model="row.input3" :readonly="board.readonly" type="number"/>
        </td>
        <td>
          <vs-input class="w-full" style="width: 80px; padding: 0" v-model="row.input4" :readonly="board.readonly" type="number"/>
        </td>
        <td>
          <vs-input class="w-full" style="width: 80px;" v-model="row.input5" :readonly="board.readonly" type="number"/>
        </td>
        <td>
          <vs-textarea v-model="row.input6" :readonly="board.readonly"  style="margin: 0px;"/>
        </td>
      </tr>

<!--      <tr>-->
<!--        <th colspan="7" style="text-align: start; font-weight: 500; padding: 10px 20px;">※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)</th>-->
<!--      </tr>-->
      </tbody>
    </table>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup id="popAlert" title="이행사항 점검 시 작성요령" :active.sync="showPopup">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>증빙자료 첨부</th>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold"> “도급인”, “수급인”, “관계수급인” 이란 ?</b>
            <ul>
              <li class="mb-1">◼ “도급인”이란 물건의 제조ㆍ건설ㆍ수리 또는 서비스의 제공, 그 밖의 업무를 도급하는 사업주를 말한다. 다만, 건설공사발주자는 제외한다.</li>
              <li class="mb-1">◼ “수급인”이란 도급인으로부터 물건의 제조ㆍ건설ㆍ수리 또는 서비스의 제공, 그 밖의 업무를 도급받은 사업주를 말한다.</li>
              <li class="mb-1">◼ “관계수급인”이란 도급이 여러 단계에 걸쳐 체결된 경우에 각 단계별로 도급받은 사업주 전부를 말한다.</li>
              <li class="mb-1">※ “건설공사”란 다은 각 목의 어느 하나에 해당하는 공사를 말한다.</li>
              <li class="mb-1 ml-3">가. 「건설산업기본법」 제2조제4호에 따른 건설공사 나. 「전기공사업법」 제2조제4호에 따른 전기공사 다. 「정보통신공사업법」 제2조제2호에 따른 소방시설공사</li>
              <li class="mb-1 ml-3">라. 「소방시설공사업법」 에 다른 소방시설공사 마. 「문화재수리 등에 관한 법률」 에 따른 문화재수리공사</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold"> 도급·용역·위탁 사업장이 여러건인 경우 사업별로 점검표 작성 또는 사업 담당자별로 점검표 작성(담당자가 사업별 자체점검 후 통합하여 점검표 작성)</b>
            <ul>
              <li class="mb-1">※ 후자의 경우, - 점검표 작성시 담당별 사업 전체 건수와 건명 기입</li>
              <li class="mb-1 ml-3">- 점검표 체크란에는 ‘숫자(건수)’ 기입</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold"> 점검결과 판단기준(연번 1~8번)</b>
            <ul>
              <li class="mb-1">1. 실시 :  점검항목을 100% 이행한 경우 (점검시점 기준)</li>
              <li class="mb-1">2. 미실시 :  점검항목을 이행 중이거나 이행하지 않은 경우</li>
              <li class="mb-1">3. 해당없음 :  점검항목과 무관한 경우</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">작성요령</b>
            <ul class="tab-ul">
              <li class="mb-1">
                <p>· 연번 1 :<span>과업내용서 등</span></p>
                <p>
                  - 과업내용서 안전보건의무 이행 기재<br />
                  - 안전보건관리 준수 서약서 징구<br />
                  <span style="color: #0029ff;">* 작성대상 : 도급·용역·위탁 사업부서</span><br />
                  <span style="color: #ff0000;">* 해당 파일(계약건별) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 2 :<span>협의체 구성 및 운영일지(회의록)작성</span></p>
                <p>
                  - 결과 보고 기안 으로 확인<br />
                  <span style="color: #0029ff;">* 작성대상 : 도급·용역·위탁 사업부서</span><br />
                  <span style="color: #ff0000;">* 운영 일지 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 3 :<span>작업장 순회점검(주1회)</span></p>
                <p>
                  - 순회점검 일지 및 체크리스트 작성여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 도급·용역·위탁 사업부서</span><br />
                  <span style="color: #ff0000;">* 점검 결과(일지 및 체크리스트) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 4 :<span>합동 안전보건점검</span></p>
                <p>
                  - 합동 안전보건점검(결과 보고 기안 대체 가능) 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 도급·용역·위탁 사업부서</span><br />
                  <span style="color: #ff0000;">* 점검 결과(결과 보고 기안) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 5 :<span>유해·위험요인에 대한 관계수급인의 안전보건의무 이행 지도·감독</span></p>
                <p>
                  - 도급·용역·위탁 사업장의 위험성평가 실시 / 특별안전보건교육 실시 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 도급·용역·위탁 사업부서</span><br />
                  <span style="color: #ff0000;">* 도급사업장의 위험성평가/특별안전보건교육(결과 보고 기안) 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 6 :<span>건설재해예방 기술지도기관 계약 체결</span></p>
                <p>
                  - 건설재해예방 기술지도기관 계약 및 기술점검 실시 여부로 판정<br />
                  ≪산업안전보건법 일부개정 ‘22.8.18.부터 건설재해예방기술지도기관의 주체가 도급인에서 발주자(자기공사포함)로 변경<br />
                  1억~120억 미만 공사 현장은 건설재해예방기술지도기관의 기술지도를 월 2회 이상(15일마다 1회) 받아야함.≫<br />
                  <span style="color: #0029ff;">* 작성대상 : 건설공사 발주 부서</span><br />
                  <span>※ “건설공사”란 다은 각 목의 어느 하나에 해당하는 공사를 말한다.</span><br />
                  <span class="ml-3">가.「건설산업기본법」 제2조제4호에 따른 건설공사</span><br />
                  <span class="ml-3">나. 「전기공사업법」 제2조제4호에 따른 전기공사</span><br />
                  <span class="ml-3">다. 「정보통신공사업법」 제2조제2호에 따른 소방시설공사</span><br />
                  <span class="ml-3">라.「소방시설공사업법」 에 다른 소방시설공사</span><br />
                  <span class="ml-3">마. 「문화재수리 등에 관한 법률」 에 따른 문화재수리공사</span><br />
                  <span style="color: #ff0000;">* 계약문서 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 7 :<span>안전보건대장작성(50억이상 공사)</span></p>
                <p>
                  - 안전보건대장 작성 여부로 판정<br />
                  <span style="color: #0029ff;">* 작성대상 : 건설공사 발주 부서</span><br />
                  <span style="color: #ff0000;">* 안전보건대장 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <p>· 연번 8 :<span>산업안전보건관리비 적정계상</span></p>
                <p>
                  - 발주부서 재해발생 가능한 사업에 대해 안전관리비 포함 발주(과업내용서, 제안요청서 등에 안전보건관리지 사항 명시)<br />
                  <span style="color: #0029ff;">* 작성대상 : 건설공사 발주 부서</span><br />
                  <span style="color: #ff0000;">* 산업안전보건관리비 계상내역 디지털 안전보건 관리 시스템에 업로드</span>
                </p>
              </li>
              <li class="mb-1">
                <div>
                  <table class="mt-4 mb-2 w-full" style="border-collapse: collapse;">
                    <tbody>
                    <tr>
                      <th style="padding: 8px 22px;"><div>(건설공사) 산업안전보건관리비</div></th>
                    </tr>
                    <tr>
                      <td style="padding: 8px 22px; text-align: center;"><span>- 산업안전보건법 제72조「건설언산업안전보건관리비 계상 및 사용기준」(고용노동부고시 제2022-43호에 따른 ‘산업안전보건관리비상 기준’참조</span></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import TableInspectDivisionEp from "@/components/TableInspectDivisionEp.vue";
import TableCustom from "@/components/TableCustom.vue";
import { inspectTable2 } from "./inspectData";

export default {
  components: {
    TableCustom,
    TableInspectDivisionEp,
    CompanySelector,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key] && key !== 'inspectList2') {
            this.form[key] = value[key];
          }
        }
        if (value.inspectList && value.inspectList.length && !value.inspectList2) {
          // 기존 저장된 문서 (inspectList2 없음) → 구버전 테이블 표시
          this.isOldVersion = true;
          this.form.inspectList2 = null;
        } else {
          const savedData = value.inspectList2 || [];
          const savedMap = {};
          savedData.forEach(function(item) { savedMap[item.id] = item; });

          if (this.form.inspectList2 === null) {
            // 최초 초기화: template 전체 생성 후 저장값 반영
            this.form.inspectList2 = inspectTable2.map(function(item) {
              if (item.type === 'section') return Object.assign({}, item);
              const saved = savedMap[item.id] || {};
              return {
                id: item.id,
                content: item.content,
                input3: saved.input3 !== undefined ? saved.input3 : '',
                input4: saved.input4 !== undefined ? saved.input4 : '',
                input5: saved.input5 !== undefined ? saved.input5 : '',
                input6: saved.input6 !== undefined ? saved.input6 : '',
              };
            });
          } else {
            // 서버 데이터가 나중에 도착한 경우: 기존 객체를 mutation하여 저장값 반영
            // (새 배열을 만들지 않으므로 무한루프 방지)
            this.form.inspectList2.forEach(function(item) {
              if (item.type === 'section') return;
              const saved = savedMap[item.id];
              if (saved) {
                if (saved.input3 !== undefined) item.input3 = saved.input3;
                if (saved.input4 !== undefined) item.input4 = saved.input4;
                if (saved.input5 !== undefined) item.input5 = saved.input5;
                if (saved.input6 !== undefined) item.input6 = saved.input6;
              }
            });
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        const emitValue = Object.assign({}, value);
        // content/type/title 등 template 데이터는 DB에 저장하지 않고 id + 입력값만 저장
        if (emitValue.inspectList2) {
          emitValue.inspectList2 = emitValue.inspectList2
            .filter(function(item) { return item.type !== 'section'; })
            .map(function(item) { return { id: item.id, input3: item.input3, input4: item.input4, input5: item.input5, input6: item.input6 }; });
        }
        emitValue.title = this.board.writer.department;
        this.$emit("input", emitValue);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      isOldVersion: false,
      form: {
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        industryList: [{ "id": 1, "input2": "", "input3": "도급" }, ],
        inspectList2: null,
        inspectList: [
          {
            input1: "(도급) 과업내용서 등<br/> · 과업내용서 안전보건의무 이행 기재<br/> · 안전보건관리 준수 서약서 징구",
            input2: "도급·용역·위탁 사업 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(도급) 협의체 구성 및 운영일지(회의록) 작성",
            input2: "도급·용역·위탁 사업 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(도급) 작업장 순회점검(주1회)",
            input2: "도급·용역·위탁 사업 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(도급) 합동 안전보건 점검",
            input2: "도급·용역·위탁 사업 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(도급) 유해·위험요인에 대한 관계수급인의 안전보건의무 이행 지도·감독<br/> · 안전조치 및 위험성평가 실시확인<br/> · 특별안전보건교육 실시확인",
            input2: "도급·용역·위탁 사업 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(발주공사)건설재해예방지도기관계약 체결(1억이상120억미만)",
            input2: "발주 공사 해당 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(발주공사)안전보건대장작성 (50억이상 공사)",
            input2: "발주 공사 해당 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
          {
            input1: "(발주공사)산업안전보건관리비 적정계상(2천만원 이상 공사)",
            input2: "발주 공사 해당 부서",
            input3: "",
            input4: "",
            input5: "",
            input6: ""
          },
        ],

        stdInfo: {},
        fileList: [],
        photoList: [],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.inputB_1 = value.com_name;
    },
    updateListCheck(indexTableRow, indexRows, text) {
      this.form.inspectList[indexTableRow].list[indexRows].is_checked = text;
    },
    openPopup() {
      this.showPopup = true;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    //margin-left: 16px;
    //list-style:none;
    &::marker {
      //content: " · ";
      //font-size: 1.2em;
    }
  }
}

.inspectTable {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #cdcdcd;

  th {
    border: 1px solid #cdcdcd;
    font-size: 14px;
    font-weight: 500;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  td {
    border: 1px solid #cdcdcd;
    padding: 5px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;

    span {
      display: flex;
      text-align: start;
    }
  }
}

</style>
